export enum INoonReportTabs {
  addNewNoonReport = "1",
  noonReportTable = "2",
}
